import { render, staticRenderFns } from "./GasbotCommandsCard.vue?vue&type=template&id=4b33930c&scoped=true"
import script from "./GasbotCommandsCard.vue?vue&type=script&lang=ts"
export * from "./GasbotCommandsCard.vue?vue&type=script&lang=ts"
import style0 from "./GasbotCommandsCard.vue?vue&type=style&index=0&id=4b33930c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33930c",
  null
  
)

export default component.exports